'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _format = require('@marmalade/format');
var _format2 = _interopRequireDefault(_format);
var _required = require('../required');
var _required2 = _interopRequireDefault(_required);
var _matches = require('../matches');
var _matches2 = _interopRequireDefault(_matches);
var _oneByOne = require('../one-by-one');
var _oneByOne2 = _interopRequireDefault(_oneByOne);
var _isNumerical = require('../is-numerical');
var _isNumerical2 = _interopRequireDefault(_isNumerical);
var _atLeast = require('../at-least');
var _atLeast2 = _interopRequireDefault(_atLeast);
var _atMost = require('../at-most');
var _atMost2 = _interopRequireDefault(_atMost);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var valueMessage = function valueMessage(min, max) {
  return 'Unfortunately you are unable to proceed if the vehicle\'s value is ' + (typeof min !== 'undefined' ? 'less than \xA3' + (0, _format2.default)('number-with-comma', min) + ' ' : '') + (typeof min !== 'undefined' && typeof max !== 'undefined' ? 'or ' : '') + (typeof max !== 'undefined' ? 'more than \xA3' + (0, _format2.default)('number-with-comma', max) : '');
};
exports.default = function (minVal, maxVal) {
  return {
    abiCode: (0, _isNumerical2.default)('Please select your vehicle'),
    value: (0, _oneByOne2.default)((0, _required2.default)('Please let us know the value of the vehicle'), (0, _matches2.default)(/^\d+(.\d{1,2})?$/, 'Please enter a valid value (only numbers and 1 decimal allowed)'), typeof minVal !== 'undefined' ? (0, _atLeast2.default)(minVal, valueMessage(minVal, maxVal)) : function () {
      return '';
    }, typeof maxVal !== 'undefined' ? (0, _atMost2.default)(maxVal, valueMessage(minVal, maxVal)) : function () {
      return '';
    })
  };
};